import { buildSearchQuery } from '@/utils/searchUrl';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export type SearchUrlState = {
  checkIn?: Date;
  checkOut?: Date;
  guests?: string;
};

export const useSearchUrlSync = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const replaceParams = useCallback(
    (state: SearchUrlState) => {
      const qs = buildSearchQuery(state);
      navigate(qs ? `${pathname}?${qs}` : pathname, { replace: true });
    },
    [navigate, pathname],
  );

  const clearParams = useCallback(
    (keys: Array<'checkin' | 'checkout' | 'guests'>) => {
      const url = new URL(window.location.href);
      keys.forEach((k) => url.searchParams.delete(k));
      navigate(
        `${pathname}${url.search ? `?${url.searchParams.toString()}` : ''}`,
        { replace: true },
      );
    },
    [navigate, pathname],
  );

  return { replaceParams, clearParams };
};
